// src/pages/DashboardHome.jsx
import React from "react";
import { Link } from "react-router-dom";


export default function DashboardHome() {
  return (
    <div className="space-y-10">
      <div>
        <h1 className="text-2xl font-semibold">
          Xush kelibsiz, asqarjon
        </h1>
        <p className="text-sm text-gray-500 mt-1">
          Bugun hisobingiz bilan nima sodir bo‘layotgani shu yerda.
        </p>
      </div>

      {/* Statistik kartalar */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        
        <div className="bg-white p-5 rounded-xl border shadow-sm">
          <p className="text-sm text-gray-500 font-medium">
            KREDITLAR BALANSI
          </p>
          <h2 className="text-3xl font-bold mt-2">cheksiz</h2>
          <p className="text-xs text-gray-400 mt-1">cheksiz dan jami</p>

          <div className="w-full h-2 bg-gray-200 rounded-full mt-3">
            <div className="h-full bg-black rounded-full" style={{ width: "93%" }}></div>
          </div>
        </div>

        <div className="bg-white p-5 rounded-xl border shadow-sm">
          <p className="text-sm text-gray-500 font-medium">
            QAYTA ISHLANGAN FAYLLAR
          </p>
          <h2 className="text-3xl font-bold mt-2">2</h2>
          <p className="text-xs text-gray-400 mt-1">jami</p>
        </div>

        <div className="bg-white p-5 rounded-xl border shadow-sm">
          <p className="text-sm text-gray-500 font-medium">
            JAMI TESTLAR
          </p>
          <h2 className="text-3xl font-bold mt-2">1</h2>
          <p className="text-xs text-gray-400 mt-1">jami</p>
        </div>
      </div>
    
      {/* Obuna */}
      <div className="bg-white rounded-xl border shadow-sm hover:bg-gray-50 p-6">
      <Link
          to="/dashboard/live"
          className=" p-5 "
        >
          <p className="font-medium">Jonli testni boshlash</p>
          <p className="text-xs text-gray-500 mt-1">
            Testni tanlang va o‘quvchilar bilan real vaqtda quiz o‘tkazing.
          </p>
        </Link>

      </div>

      {/* Tezkor harakatlar */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        <Link to="/dashboard/create" className="bg-white p-5 rounded-xl border shadow-sm hover:bg-gray-50">
          <p className="font-medium">Yangi fayl yuklash</p>
          <p className="text-xs text-gray-500 mt-1">
            Hujjat yoki pdf fayl  yuklash
          </p>
        </Link>

        <Link to="/dashboard/tests" className="bg-white p-5 rounded-xl border shadow-sm hover:bg-gray-50">
          <p className="font-medium">Mening testlarimni ko‘rish</p>
          <p className="text-xs text-gray-500 mt-1">
            Testlarni boshqarish va ko‘rish
          </p>
        </Link>

        <Link to="/dashboard/profile" className="bg-white p-5 rounded-xl border shadow-sm hover:bg-gray-50">
          <p className="font-medium">Profilni tahrirlash</p>
          <p className="text-xs text-gray-500 mt-1">
            Hisob sozlamalarini yangilash
          </p>
        </Link>
      </div>
    </div>
  );
}
